import React, { useMemo, useState, useEffect, useCallback } from "react";
import Customtable from "../helper/Customtable";
import Swal from "sweetalert2";
import { post } from "../helper/api_helper";

const Despatch_party_wise_report = () => {
    const [despatchList, setDespatchList] = useState([]);
    const [totals, setTotals] = useState({ total_bales: 0, total_qty_mts: 0, total_freight: 0 });
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(false);

    // Filter state
    const [consigneeOptions, setConsigneeOptions] = useState([]);
    const [despatchDate, setDespatchDate] = useState(
        new Date().toISOString().split("T")[0]
    );
    const [consigneeId, setConsigneeId] = useState("");

    // ------------------------------
    // Alert Helper
    // ------------------------------
    const showAlert = useCallback((icon, title, text, timer = 2000) => {
        Swal.fire({
            icon,
            title,
            text: text || "Something went wrong.",
            timer,
            showConfirmButton: false,
        });
    }, []);

    // ------------------------------
    // Fetch Data
    // ------------------------------
    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const payload = {};
            if (despatchDate) payload.despatch_date = despatchDate;
            if (consigneeId) payload.consignee_id = consigneeId;

            const response = await post("/reports/despatch_party_wise_report/list", payload);
            if (response.status === 200) {
                setDespatchList(response.data || []);
                setTotals(response.totals || { total_bales: 0, total_qty_mts: 0, total_freight: 0 });
            } else {
                showAlert("error", response.status, response.message);
            }
        } catch (err) {
            showAlert("error", "Unexpected Error", err.message);
        } finally {
            setLoading(false);
        }
    }, [showAlert, despatchDate, consigneeId]);

    const fetchConsigneeData = useCallback(async () => {
        try {
            const response = await post("/masters/consignees/list");
            if (response.status === 200) {
                setConsigneeOptions([
                    { value: "", label: "Select Consignee" },
                    ...response.data.map(item => ({
                        value: item.consignees_id,
                        label: item.consignees_name,
                    }))
                ]);
            }
        } catch (err) {
            console.log(err.message);
        }
    }, []);

    useEffect(() => {
        fetchData();
        fetchConsigneeData();
    }, [fetchData, fetchConsigneeData]);

    const despatchColumns = useMemo(
        () => [
            { header: "SL NO", accessorKey: "si_no", enableColumnFilter: false, enableSorting: false },
            { header: "Lorry Nos.", accessorKey: "lorry_number" },
            { header: "Bales", accessorKey: "bales", isTotal: true },
            { header: "Qty (Mts)", accessorKey: "qty_mts", isTotal: true },
            { header: "Freight (Rs.)", accessorKey: "freight" },
            { header: "Average FRT", accessorKey: "average_frt" },
            { header: "Eway Bill", accessorKey: "eway_bill" },
            { header: "GC No", accessorKey: "gc_no" },
            { header: "GC Date", accessorKey: "gc_date" },
            { header: "Remarks", accessorKey: "remarks" },
        ],
        []
    );

    return (
        <>
            <div className="page-header d-flex justify-content-between align-items-center">
                <div>
                    <div className="page-header-title">Despatch Party Wise Report</div>
                </div>
            </div>

            {/* Filters */}
            <div className="card mt-3">
                <div className="card-body">
                    <div className="row g-3 align-items-end">
                        <div className="col-md-3">
                            <label className="form-label">Despatch Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={despatchDate}
                                onChange={(e) => setDespatchDate(e.target.value)}
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">Consignee</label>
                            <select
                                className="form-select"
                                value={consigneeId}
                                onChange={(e) => setConsigneeId(e.target.value)}
                            >
                                {consigneeOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <button className="btn btn-primary w-100" onClick={fetchData} disabled={loading}>
                                {loading ? "Loading..." : "Search"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Party Wise Despatch Table */}
            <div className="card basic-data-table mt-3">
                <div className="card-header bg-primary text-white">
                    <h5 className="card-title mb-0 text-white"> Despatch Party Wise Report</h5>
                </div>
                <div className="card-body">
                    <Customtable
                        table_title="Despatch Party Wise"
                        columns={despatchColumns}
                        data={despatchList}
                        isGlobalFilter={true}
                        isPagination={true}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        isExportButton={true}
                    />
                    {despatchList.length > 0 && (
                        <div className="text-end fw-bold mt-2 pe-3">
                            TOTAL — Bales: {totals.total_bales} | Qty (Mts): {totals.total_qty_mts} | Freight: {totals.total_freight}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default Despatch_party_wise_report;